import React, { useRef, forwardRef, useImperativeHandle } from "react";
import ReCAPTCHA from "react-google-recaptcha";

const Recaptcha = forwardRef(({ siteKey, onChange, theme = "light", onToken }, ref) => {
  const recaptchaRef = useRef(null);
  
  useImperativeHandle(ref, () => ({
    execute: () => recaptchaRef.current.execute(),
    reset: () => recaptchaRef.current.reset(),
  }));

  return (
    <ReCAPTCHA
      ref={recaptchaRef}
      sitekey={siteKey}
      onChange={onToken}
      theme={theme}
      size="invisible"
      badge="bottomright"
    />
  );
});

export default Recaptcha;
